import {css} from '@yandex-delivery/blocks/theme/css'

export const root = css`
  block-size: 100vh;
  border-radius: 0;
  inline-size: 100%;
  max-block-size: 100vh;
  padding: 0;
`
